import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { Register } from '../../_models/register';
import { Warehouse } from '../../_models/warehouse';
import { OrderLine } from '../../_models/orderLine';
import { OrderHeader } from '../../_models/orderHeader';
import { Contacts } from '../../_models/contacts';
import { Product } from '../../_models/product';
import { Globals } from '../../_models/globals';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as _ from "lodash";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-split-order',
  templateUrl: './split-order.component.html',
  styleUrls: ['./split-order.component.scss'],
})
export class SplitOrderComponent implements OnInit {

  tabClicked = "selectedProducts";
  step: number = 1;
  destWarehouseId: any;
  progressWidth: any;
  order: OrderHeader = {};
  contacts: any;
  warehouses: any = [];
  activeProducts: any;
  orderLine: OrderLine = {};
  orderLines: OrderLine[] = [];
  activeProduct: Product = {};
  shippingMethod: string;
  shippingOption: string;
  statusText1: string = "";
  statusText2: string = "";
  statusText3: string = "";
  statusText4: string = "";
  statusText5: string = "";
  statusText6: string = "";
  quantity: number = 0;
  deliveryInstructions: string;
  contactAddressText: string;
  addressText: string;
  warehouseAddressText: string;

  warehouse: Warehouse = {
    name: "",
    warehouseType: " ",
    noOfUnits: null,
    status: "",
    totalSpace: null,
    cost: null,
    organizationId: null,
    warehouseId: null,
    accountOwnerId: null,
    addressText: ""
  };

  contact: Contacts = {
    companyName: "",
    contactName: "",
    accountOwners: "",
    accountOwnerContacts: "",
    mobile: "",
    email: "",
    deliveryInstructions: "",
    status: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    addressText: "",
    addressId: null,
    accountOwnerId: null,
    organizationId: null,
    accountOwnerContactId: null
  };
  selectedProducts: any = [];
  removedProducts: any = [];
  totalQty = 0;
  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, private api: ApiIntegration, private route: ActivatedRoute, private router: Router, public user: User, public register: Register) {

    this.g.page = "Edit Order";
    this.g.loaderDisplay = "display";
    this.api.getStockTransferDetailsId(this.route.snapshot.params['id'], "1").subscribe((data: OrderHeader) => {
      this.g.loaderDisplay = "";
      this.order = data;
      this.getAOContactsByStatus("ACTIVE");
      this.getWarehouseColumnList();
      this.orderLines = _.cloneDeep(this.order.lines);
      this.totalQty = 0;
      this.orderLines.forEach((l) => {
        l['previousQty'] = l.quantity;
        this.totalQty = Number(l.quantity) + this.totalQty;
      });
    },
      err => {
        this.alertService.error('Error', err);
      });
  }
  showQtyCheckIcon(ol) {
    if (ol.previousQty > ol.quantity && Number(ol.quantity) > 0) {
      return true;
    } else { return false; }
  }
  getAOContactsByStatus(status) {
    this.g.loaderDisplay = "display";
    this.api.getAOContactsByStatusAndAOIdAndOrgId("1", this.user.accountOwnerId || this.order.accountOwnerId, status).subscribe((data: any) => {
      this.contacts = data;
      for (let c of this.contacts) {
        if (c.contactName === this.order.accountOwnerCustomerName) {
          this.contact = c;
          this.contactAddressText = this.contact.addressText;
        }
      }
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }


  tabChange(tab) {
    this.tabClicked = tab
  }

  getContactAddress() {
    this.contactAddressText = (this.contact || {}).addressText || '';
  }
  getWarehouseAddress() {
    this.warehouseAddressText = (this.warehouse || {}).addressText || '';
  }
  customSearchFn(term: string, item: any = []) {
    term = term.toLowerCase();
    return item.contactName.toLowerCase().indexOf(term) > -1 || (item.companyName && item.companyName.toLowerCase().indexOf(term) > -1);
  }
  getWarehouseColumnList() {
    this.g.loaderDisplay = "display";
    if (this.user.role === "ACCOUNT_OWNER" || this.user.role === "ROLE_USER" || this.user.role === "ROLE_ADMIN") {
      this.api.getWarehouseColumnList(this.user.accountOwnerId || this.order.accountOwnerId, "1").subscribe((data: any) => {
        this.warehouses = data.getWarehousesResponses;
        this.g.loaderDisplay = "";
        for (let w of this.warehouses) {
          if (w.name === this.order.sourceWarehouseName) {
            this.warehouse = w;
            this.warehouseAddressText = this.warehouse.addressText;
          }
        }
      }, err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
    } else {
      this.api.getWarehouseColumnList(this.register.Id, "1").subscribe((data: any) => { this.warehouses = data.getWarehousesResponses; this.g.loaderDisplay = ""; }, err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
    }
  }
  getProductsList() {
    if (this.user.role === "ACCOUNT_OWNER" || this.user.role === "ROLE_USER") {
      this.api.getProductsByWarehouse((this.user.accountOwnerId || (this.contact || {}).accountOwnerId), this.warehouse.warehouseId, "1").subscribe((data: any) => { this.activeProducts = data.getProductResponses; }, err => {
        this.alertService.error('Error', err);
      });
    } else {
      this.api.getProductsByWarehouse((this.register.Id || (this.contact || {}).accountOwnerId), this.warehouse.warehouseId, "1").subscribe((data: any) => { this.activeProducts = data.getProductResponses; }, err => {
        this.alertService.error('Error', err);
      });
    }
  }

  selectProductForEditOrder() {
    if (this.activeProduct !== null && this.activeProduct !== undefined
      && this.activeProduct.productName !== null && this.activeProduct.productName !== undefined) {
      this.orderLine = this.activeProduct;
      if (this.removedProducts.length) {
        let index = this.removedProducts.findIndex((d) => d.productId == this.activeProduct.productId);
        if (index > -1) {
          this.removedProducts.splice(index, 1);
        }
      }
      this.orderLine.quantity = this.quantity;
      this.orderLines.push(_.cloneDeep(this.orderLine));
      this.activeProduct = null;
      this.quantity = undefined;
      this.selectedProducts = this.removedProducts;

    }
  }
  recipientInformation() {
    this.step = 1;
    this.progressWidth = "25%";
  }
  backAddProducts() {
    this.step = 2;
    this.progressWidth = "50%";
  }

  clearFields() {
    this.contact = null;
    this.warehouse = null;
    this.contactAddressText = null;
    this.warehouseAddressText = null;
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.activeProduct = null;
    for (let ol of this.orderLines) {
      let i = this.orderLines.indexOf(ol);
      this.orderLines.splice(i, 1);
    }
    this.statusText5 = "";
    this.order.shippingOption = "";

  }

  selectShippingInformation() {
    this.step = 1;
  }

  reviewAndConfirm() {

    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";

    if (this.contact === null || this.contact === undefined) {
      this.statusText1 = 'Please select customer';
    }
    if (this.warehouse === null || this.warehouse === undefined) {
      this.statusText2 = 'Please select warehouse';
    }

    if (this.orderLines.length === 0) {
      this.statusText3 = 'Please select product';
    }
    for (let ol of this.orderLines) {
      if (ol.quantity === null || ol.quantity === undefined || ol.quantity <= 0) {
        this.statusText4 = 'Please enter quantity as minimum 1';
      }
    }
    if (this.order.shippingOption === null || this.order.shippingOption === undefined || this.order.shippingOption === '' || this.order.shippingOption === 'undefined') {
      this.statusText5 = 'Please select shipping Option';
    }
    if (this.statusText3 != '' || this.statusText4 != '' || this.statusText1 != '' || this.statusText2 != '') {
      return false;
    }

    if (this.totalQty == 1) {
      this.alertService.error('Error', "We can not split for this order. Order should have atleast total quantity '2' or atleast '2' products");
      return;
    }
    let totalQuantity = 0;
    this.orderLines.forEach((d) => {
      totalQuantity = Number(totalQuantity) + Number(d.quantity);
      if (d.previousQty < d.quantity || Number(d.quantity) <= 0) {
        return;
      }
    });
    if (this.totalQty <= totalQuantity) {
      this.alertService.error('Error', "Reduce the quantity or product");
      return;
    }
    this.getProductsList();
    this.order.warehouseId = this.warehouse.warehouseId;
    this.order.sourceWarehouseName = this.warehouse.name;
    this.order.accountOwnerCustomerName = this.contact.contactName;
    this.order.accountOwnerContactId = this.contact.accountOwnerContactId;
    if (this.tabClicked != 'shippingOptions') {
      this.tabClicked = 'shippingOptions';
      return;
    }
    if (this.order.shippingOption === null || this.order.shippingOption === undefined || this.order.shippingOption === '' || this.order.shippingOption === 'undefined') {
      this.statusText5 = 'Please select shipping Option';
      return;
    }
    this.step = 4;
    this.progressWidth = "100%";
  }

  removeProduct(rp) {
    let index = this.orderLines.indexOf(rp);
    this.orderLines.splice(index, 1);
    rp.quantity = 0;
    rp.id = rp.orderLineId;
    this.removedProducts.push(rp);
    this.selectedProducts = this.removedProducts;
  }


  ngOnInit() { }
  submitEditOrder() {
    if (this.totalQty == 1) {
      this.alertService.error('Error', "We can not split for this order. Order should have atleast total quantity '2' or atleast '2' products");
      return;
    }
    let totalQuantity = 0;
    this.orderLines.forEach((d) => {
      d.status = 'SPLITTER';
      d.id = d.orderLineId;
      totalQuantity = Number(totalQuantity) + Number(d.quantity);
      if (d.previousQty < d.quantity || Number(d.quantity) <= 0) {
        return;
      }
    });
    if (this.totalQty <= totalQuantity) {
      this.alertService.error('Error', "Reduce the quantity or product");
      return;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/splitOutBoundOrder', {
      "accountOwnerContactId": this.contact.accountOwnerContactId,
      "accountOwnerId": this.user.accountOwnerId || this.order.accountOwnerId,
      "deliveryInstructions": this.order.deliveryInstructions,
      "shippingOption": this.order.shippingOption,
      // "shippingMethod": this.order.shippingMethod,
      "additionalInfo": this.order.additionalInfo,
      "organizationId": 1,
      "warehouseId": this.warehouse.warehouseId,
      "lines": [...this.orderLines, ...this.removedProducts],
      "orderType": "ORDER",
      "orderStatus": "SPLITTER",
      "orderHeaderId": this.route.snapshot.params['id'],
      "orderNumber": this.order.orderNumber
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Edited Successfully');
          if (this.user.role == "ACCOUNT_OWNER") {
            this.router.navigate(['/admin/orders']);
          } else {
            this.router.navigate(['/admin/adminOrder']);
          }
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  draftOrder() {
    this.g.loaderDisplay = "display";

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createOrderHeaders', {
      "accountOwnerContactId": this.contact.accountOwnerContactId,
      "accountOwnerId": this.user.accountOwnerId,
      "deliveryInstructions": this.order.deliveryInstructions,
      "shippingOption": this.order.shippingOption,
      "shippingMethod": this.order.shippingMethod,
      "organizationId": 1,
      "warehouseId": this.warehouse.warehouseId,
      "lines": this.orderLines,
      "orderType": "ORDER",
      "orderStatus": "DRAFT",
      "orderHeaderId": this.route.snapshot.params['id'],
      "orderNumber": this.order.orderNumber
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Draft', 'Edited Successfully');
          this.router.navigate(['/admin/orders']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
  open() {
    //this.selectedProducts = _.cloneDeep(this.activeProducts);
    this.selectedProducts = _.cloneDeep(this.selectedProducts);
    for (let i = 0; i < this.orderLines.length; i++) {
      let index = this.selectedProducts.findIndex((d) => d.productName === this.orderLines[i].productName);
      if (index > -1) {
        this.selectedProducts.splice(index, 1);
      }
    }
    console.log(this.selectedProducts);
  }
}
